import { Component } from '@angular/core';

@Component({
  selector: 'app-klm-footer',
  templateUrl: './klm-footer.component.html',
  styleUrls: ['./klm-footer.component.css']
})
export class KlmFooterComponent {

}
